import styled, { keyframes } from "styled-components/macro"
const show = keyframes`
  from {
    opacity:0;
  }

  to {
    opacity:1;
  }
`
const hide = keyframes`
  from {
    opacity:1;
  }

  to {
    opacity:0;
  }
`
export const LightBoxWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
`

export const MaskLayer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0;
  animation: ${show} 0.25s ease-in-out 0.1s forwards;
  background-color: rgba(0, 28, 49, 0.9);
  z-index: 1;
  text-align: center;
  &.is-hide {
    animation: ${hide} 0.5s ease-in-out forwards;
  }
`
export const HeaderLayer = styled.div`
  padding: 16px 10%;
  position: absolute;
  width: 100%;
  top: 0;
  height: 60px;
  left: 0;
  z-index: 2;
  overflow: auto;
  background-color: #001c31;
  font-size: 22px;
  color: #ffffff;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`

export const ContentLayer = styled.div`
  position: absolute;
  width: 100%;
  top: 60px;
  left: 0;
  height: calc(100% - 60px);
  z-index: 2;
  overflow: auto;
  .gatsby-image-wrapper {
    margin: auto;
    width: 80% !important;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`

export const CloseIconWrapper = styled.div`
  width: 16px;
  height: 16px;
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`
